import PagesController from 'controllers/PagesController';
import ComponentsManager from "controllers/ComponentsManager";
import Contact from './Contact';
import ContactHeader from "./ContactHeader";
import Schedules from "./Schedules";
import ContactEmails from "./ContactEmails";


export default new class {
	constructor() {
		PagesController.addPage( 'contact', Contact );
		ComponentsManager.register( 'contact_header', ContactHeader );
		ComponentsManager.register( 'contact_emails', ContactEmails );
		ComponentsManager.register( 'schedules', Schedules );
	}
};
